import { addDoc, collection, deleteDoc, doc, getDocs, serverTimestamp, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '@/config/firebase';
import type { AuditoriaAtor } from '../models';
import type { DadosClienteSolicitacao, ModeloEmailCliente, ModeloEmailClienteSalvar } from '../models/emailCliente.modelos';

const COLECAO = 'si_config_emails_cliente';

/** Modelos de e-mail para o Cliente (ver emailCliente.modelos.ts). Qualquer pessoa logada lê
 * (a abertura precisa saber quais campos pedir); só o SI escreve (firestore.rules). */
export const emailClienteService = {
  async listar(): Promise<ModeloEmailCliente[]> {
    const snap = await getDocs(collection(db, COLECAO));
    return snap.docs
      .map((d) => {
        const dados = d.data();
        return {
          id: d.id,
          clienteId: dados.clienteId ?? '',
          clienteNome: dados.clienteNome ?? '',
          momento: dados.momento ?? 'entrada',
          tiposSolicitacao: dados.tiposSolicitacao ?? [],
          para: dados.para ?? [],
          cc: dados.cc ?? [],
          assunto: dados.assunto ?? '',
          corpo: dados.corpo ?? '',
        } as ModeloEmailCliente;
      })
      .sort((a, b) => a.clienteNome.localeCompare(b.clienteNome, 'pt-BR') || a.momento.localeCompare(b.momento));
  },

  /** Cria (sem id) ou atualiza; devolve o id. */
  async salvar(modelo: ModeloEmailClienteSalvar, por: AuditoriaAtor): Promise<string> {
    const { id, ...dados } = modelo;
    const registro = { ...dados, atualizadoEm: serverTimestamp(), atualizadoPor: { id: por.id, name: por.name } };
    if (id) {
      await setDoc(doc(db, COLECAO, id), registro);
      return id;
    }
    return (await addDoc(collection(db, COLECAO), registro)).id;
  },

  async excluir(id: string): Promise<void> {
    await deleteDoc(doc(db, COLECAO, id));
  },

  /** SI corrige/completa o bloco "Dados para o cliente" da Solicitação (tela do e-mail). */
  async salvarDadosCliente(solicitacaoId: string, dadosCliente: DadosClienteSolicitacao, por: AuditoriaAtor): Promise<void> {
    await updateDoc(doc(db, 'si_solicitacoes', solicitacaoId), {
      dadosCliente,
      updatedBy: { id: por.id, name: por.name, avatar: por.avatar ?? null },
      updatedAt: serverTimestamp(),
    });
  },
};
